export default "__VITE_ASSET__9i17u1nN6xOO2zERFy_0aw__"